import useSignupHook from "../hooks/auth/useSignupHook";
import useVerifyHook from "../hooks/auth/useVerifyHook";
import useRegisterHook from "../hooks/auth/useRegisterHook";
import useSigninHook from "../hooks/auth/useSigninHook";
import useForgotPassword from "../hooks/auth/useForgotPassword";
import useResetPassword from "../hooks/auth/useResetPassword";
import useTeamSetup from "../hooks/auth/useTeamSetup";
import useSelectTeam from "../hooks/auth/useSelectTeam";
import useSettingsHook from "../hooks/auth/useSettingsHook";
import useBoardHook from "../hooks/board/useBoardHook";
import useCardWrapper from "../hooks/board/useCardWrapper";
import useBlock from "../hooks/board/useBlock";
import useTask from "../hooks/board/useTask";
import useSideBar from "../hooks/sidebar/useSideBar";
import useEventHook from "../hooks/board/useEvent";
import useEventListHook from "hooks/dashboard/useEventList";
import useChatHook from "hooks/chat/useChathook";
import useTaskHook from "hooks/board/useTaskHook";
import usePromptHook from "hooks/prompt/usePromptHook";
import useMessages from "hooks/chat/useMessages";
import useNewFete from "hooks/chat/useNewFeteHook";
import useVendor from "hooks/vendor/useVendor"

const containers = {
  signup: useSignupHook,
  register: useRegisterHook,
  verify: useVerifyHook,
  login: useSigninHook,
  resetPassword: useResetPassword,
  forgotPassword: useForgotPassword,
  teamSetup: useTeamSetup,
  selectTeam: useSelectTeam,
  settings: useSettingsHook,
  boardData: useBoardHook,
  eventData: useEventHook,
  cardWrapper: useCardWrapper,
  blockWrapper: useBlock,
  sidebar: useSideBar,
  cardTask: useTask,
  eventList: useEventListHook,
  chatBox: useChatHook,
  taskHook: useTaskHook,
  promptHook: usePromptHook,
  chatMessages: useMessages,
  newFeteChat: useNewFete,
  vendorHook: useVendor
};

export default containers;
